export default __webpack_public_path__ + "static/map-5bdbd2a7b503af36a64b3b5301a0e619.png";